import type { JSX } from 'solid-js';
import { Dynamic } from 'solid-js/web';
import { cx } from '../cx';
import type { ClassMap } from './variant';

// The one panel primitive: hairline border, flat fill, no shadow. A marketing
// card and a dashboard card are this component at a different `pad`. The fill
// follows the band it sits in (`tone="panel"` reads the band's panel surface),
// so a panel never needs to know which band it landed in.
export type PanelTone = 'panel' | 'raised' | 'bare';
export type PanelPad = 'sm' | 'md' | 'lg';
export type PanelElement = 'section' | 'div' | 'article' | 'li';

export type PanelProps = {
  readonly tone?: PanelTone;
  readonly pad?: PanelPad;
  readonly as?: PanelElement;
  readonly children: JSX.Element;
};

export const PANEL_TONE_CLASS: ClassMap<PanelTone> = {
  panel: 'ui-panel--tone-panel',
  raised: 'ui-panel--tone-raised',
  bare: 'ui-panel--tone-bare',
};

export const PANEL_PAD_CLASS: ClassMap<PanelPad> = {
  sm: 'ui-panel--pad-sm',
  md: 'ui-panel--pad-md',
  lg: 'ui-panel--pad-lg',
};

export function Panel(props: PanelProps): JSX.Element {
  return (
    <Dynamic
      component={props.as ?? 'div'}
      class={cx(
        'ui-panel',
        PANEL_TONE_CLASS[props.tone ?? 'panel'],
        PANEL_PAD_CLASS[props.pad ?? 'md'],
      )}
    >
      {props.children}
    </Dynamic>
  );
}
